import preview from "../customer-area/virtualScroll/preview";

export default (images,image) => ({
    images,
    image,
    adding: false,
    package: null,
    preview: null,
    ...preview,

    init() {
        this.package = _.get(this.images, this.image-1, null);

        this.$nextTick(() => {
            this.preview = this.$refs.preview;

            this.movePreviewToOutside();
        });
    },

    packageCode() {
        let packageEventCode = this.package?.event?.code;
        return packageEventCode ? `${packageEventCode}_${this.package?.code.split('_').pop()}` : this.package?.code;
    },
    
    removeImage() {
            this.images[this.image - 1] = null;
            this.package = null
    },

    openHighResImage() {
        window.open(this.images[this.image - 1].high_res, '_blank')
    }
});
